import { Selector } from "react-redux";

import { IAppState } from "@multiweb/types/react";

/**
 * Získá z globálního stavu podstrom patřící auth modulu.
 */
const getModel = (state: IAppState) => state.core.auth;

/**
 * Získá přihlašovací jméno přihlášeného uživatele.
 */
export const getUserName: Selector<IAppState, string | null> = (state) => getModel(state).userName;

/**
 * Získá jméno přihlášeného uživatele.
 */
export const getDisplayName: Selector<IAppState, string | null> = (state) => getModel(state).displayName;
